<template>
    <div>
        <div class="row mt-2 mb-2" v-if="loading">
            <div class="col-sm-12 text-center">
                <span><i class="far fa-circle-notch fa-spin"></i> Récupération des données en cours</span>
            </div>
        </div>

        <div class="row" v-if="notification.show">
            <div class="col-sm-12">
                <div  class="mb-2 mt-2 ml-2 mr-2" :class="['alert', notification.type === 'success' ? 'alert-success' : 'alert-danger', 'alert-dismissible', 'fade', 'show']" role="alert">
                    {{ notification.message }}
                    <button type="button" class="close" @click="notification.show = false">
                        <span>&times;</span>
                    </button>
                </div>
            </div>
        </div>

        
     

        <template  v-if="!loading && booking != null && booking.id">
            <div class="row">
                <div class="col-sm-12 text-center mt-2">
                    <h5>Réservation de stock : {{ booking.number }}</h5>
                </div>
            </div>
            
            <div class="row  mt-2 mb-2 mr-2 ml-2" v-show="booking.can_edit">
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Date de réservation</label>
                        <div class="input-group" style="width: 300px !important">
                            <input 
                                type="text" 
                                class="form-control" 
                                placeholder="jj/mm/aaaa" 
                                v-model="bookingDate" 
                        
                                id="bookingDatepicker"
                            >
                            <div class="input-group-append">
                                <button 
                                    class="btn btn-outline-primary" 
                                    type="button" 
                                    @click="applyDateToAll"
                                    :disabled="!bookingDate">
                                    <i class="far fa-calendar-check"></i> Appliquer
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6 text-right" v-if="dateOrder">
                    Date de livraison : 
                    <b>{{ dateOrder }}</b>
                </div>
            </div>
            <div class="row mt-2 mb-2 mr-2 ml-2">
                <div class="col-sm-12">
                    <div class="ix-table-box">
                        <table class="ix-table ix-table-sm">
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th class="text-left">Réf. article</th>
                                        <th class="text-left">Article</th>
                                        <th class="text-center">Quantité à réserver</th>
                                        <th class="text-center">Quantité totale</th>
                                        <th class="text-center">Date de réservation souhaitée</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <template v-show="booking.booking_lots && booking.booking_lots.length > 0" >
                                        <tr v-for="(bookingLotArticle, bookingLotIndex) in booking.booking_lots" 
                                            is="booking-lot-article-line"
                                            :key="'lot-article-' + bookingLotArticle.id"
                                            v-on:line-deleted="deleteRow($event)"
                                            :can-edit="booking.can_edit"
                                            :index="bookingLotIndex"
                                            :lot="bookingLotArticle">
                                        </tr>
                                        <tr v-if="(!booking.booking_articles || booking.booking_articles.length === 0) && booking.booking_lots && booking.booking_lots.length == 0">
                                            <td colspan="5" style="padding: 10px;">Aucun lot trouvé</td>
                                        </tr>
                                </template>
                                <tbody>
                                    <template v-show="(!booking.booking_lots || booking.booking_lots.length === 0) && booking.booking_articles && booking.booking_articles.length > 0">
                                        <tr class="ix-table-row-secondary">
                                            <th colspan="7">Non allotis</th>
                                        </tr>
                                        <tr v-for="(bookingArticle, articleIndex) in booking.booking_articles" 
                                            is="booking-article-line"
                                            :key="'article-' + bookingArticle.id"
                                            v-on:line-deleted="deleteRow($event)"
                                            :can-edit="booking.can_edit"
                                            :index="articleIndex"
                                            :line="bookingArticle">
                                        </tr>
                                        <tr v-if="booking.booking_articles && booking.booking_articles.length == 0">
                                            <td colspan="5" style="padding: 10px;">Aucun article trouvé</td>
                                        </tr>
                                    </template>
                                </tbody>

                        </table>
                    </div>
                </div>
            </div>
           

            <div class="row mt-2 mb-2 mr-2 ml-2" v-if="!loading && booking != null && booking.id">
                <div class="col-sm-6 text-left"  v-if="booking.can_edit">    
                    <button type="button" class="ix-btn link" @click="openModalBooking(null)"><i class="far fa-plus"></i> Nouvelle ligne</button>
                </div>
                <div class="col-sm-6 text-right" v-if="booking.can_edit">
                    <button class="ix-btn green" @click="saveChanges" :disabled="loading">
                        <i class="far fa-save"></i> Enregistrer
                    </button>
                </div>
            </div>

            <booking-modal
                :lot-url="lotUrl"
                :article-url="articleUrl"
                :booking="booking"
                :store-booking-line-url="storeUrl"
                :order-id="orderId"
                @booking-saved="getData">
            </booking-modal>
        </template>
        <template v-if="!loading && booking != null && !booking.id">
            <div class="row text-center mt-2 ml-2 mr-2">
                <div class="col-sm-12">
                    <div class="alert alert-warning">
                        Aucune réservation associée à la commmande trouvée. <a :href="generateOrderUrl" class="ix-link"><br>Cliquez ici pour générer votre réservation</a>
                    </div>
                </div>
            </div>
        </template>
    </div>

</template>
<script>
import $ from 'jquery'
import BookingArticleLine from './BookingArticleLine.vue';
import BookingLotArticleLine from './BookingLotArticleLine.vue';
import BookingModal from './BookingModal.vue';

export default {
    props: ['route', 'updateUrl', 'articleUrl', 'orderId', 'destroyLineUrl', 'storeUrl', 'dateOrder','generateOrderUrl', 'lotUrl'],
    components : {
        BookingArticleLine,
        BookingLotArticleLine,
        BookingModal
    },
    data() {
        return {
            booking: null,
            article : [],
            loading: false,
            notification: {
                message: '',
                type: '',
                show: false
            },
            lots: [],
            bookingDate: '',
        }
    },
    methods: {
        updateAllDates(date) {
            // Mettre à jour la date pour tous les lots
            if (this.booking.booking_lots) {
                this.booking.booking_lots.forEach(lot => {
                    lot.booked_start_at = date
                    lot.booking_articles.forEach(article => { article.booked_start_at = date})
                });
            }
            // Mettre à jour la date pour tous les articles
            if (this.booking.booking_articles) {
                this.booking.booking_articles.forEach(article => {
                    article.booked_start_at = date;
                });
            }
        },
        showNotification(message, type = 'success') {
            this.notification = {
                message,
                type,
                show: true
            };
            setTimeout(() => {
                this.notification.show = false;
            }, 3000);
        },
        async deleteRow(event) {
            try {
                const response = await fetch(this.destroyLineUrl, {
                    method: 'DELETE',
                    headers: this.getHttpJsonRequestHeaders().headers,
                    body: JSON.stringify({
                        booking_article_id: event.booking_article_id ? event.booking_article_id : null,
                        booking_lot_id: event.booking_lot_id ? event.booking_lot_id : null
                    })
                });

                if (!response.ok) {
                    throw new Error('Erreur lors de la suppression');
                }

                this.showNotification('La ligne a été supprimée avec succès', 'success');
                await this.getData();
            } catch (error) {
                console.error(error);
                this.showNotification('Une erreur est survenue lors de la suppression', 'error');
            }
        },
        openModalBooking(){
            $('#BookingModal').modal();
        },
        async getData() {
            this.loading = true;
            fetch(this.route + '?order_id=' + this.orderId, {
                ...{
                    method: 'GET'
                },
                ...this.getHttpJsonRequestHeaders()
            }).then((response) => {
                return response.json();
            }).then((data) => {
                this.booking = data.booking
                this.loading = false;
                // Réinitialiser le datepicker après le chargement des données
                this.$nextTick(() => {
                    $("#bookingDatepicker").datepicker({
                        format: "dd/mm/yyyy",
                        todayBtn: true,
                        language: "fr",
                        calendarWeeks: true,
                        autoclose: true,
                        todayHighlight: true,
                        clearBtn: false,
                        startDate: new Date()
                    });

                    $("#bookingDatepicker").change((e) => {
                        const date = $(e.target).val();
                        this.bookingDate = date;
                    });
                });
            }).catch((error) => {
                console.log(error);
            });
        },
        async saveChanges() {
            this.loading = true;
            try {
                const response = await fetch(this.updateUrl, {
                    method: 'PUT',
                    headers: this.getHttpJsonRequestHeaders().headers,
                    body: JSON.stringify({
                        order_id: this.orderId,
                        booking: this.booking
                    })
                });

                const data = await response.json();
                if(data.success){
                    this.showNotification('Les modifications ont été enregistrées avec succès', 'success');
                    await this.getData();
                } else {
                    this.showNotification('Une erreur est survenue lors de l\'enregistrement', 'error');
                }
            } catch (error) {
                console.error(error);
                this.showNotification('Une erreur est survenue lors de l\'enregistrement', 'error');
            } finally {
                this.loading = false;
            }
        },
        applyDateToAll() {
            if (this.bookingDate) {
                this.updateAllDates(this.bookingDate);
            }
        }
    },
    async mounted(){
        await this.getData();
    },
}

</script>